<template>
  <div>
    <bar-chart
      :height="height"
      :chart-data="chartConfig"
    />
    <div class="d-flex flex-column flex-md-row justify-content-center">
      <div class="px-3"><strong>Menor valor:</strong>  {{ min }}</div>
      <div class="px-3"><strong>Média:</strong>        {{ avg }}</div>
      <div class="px-3"><strong>Maior valor:</strong>  {{ max }}</div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/Charts/BarChart";

export default {
  name: 'AvaliationLikertScaleChart',
  components: { BarChart },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    avaliationItem: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 250,
    },
  },
  methods: {
    buttonColor(value) {
      const referenceValue = (this.max_value - this.min_value) / 3

      if (value - this.min_value < referenceValue) {
        return '#f5365c'
      }

      if (this.max_value - value < referenceValue) {
        return '#2dce8a'
      }

      return '#fb6340'
    },
  },
  computed: {
    min_value() {
      if (!this.avaliationItem || !this.avaliationItem.config) return 1;
      return parseFloat(this.avaliationItem.config.min_value) || 1;
    },
    max_value() {
      if (!this.avaliationItem || !this.avaliationItem.config) return 10;
      return parseFloat(this.avaliationItem.config.max_value) || 10;
    },
    min() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.min) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    avg() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.avg) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    max() {
      if (!this.chartData || !this.chartData.data) return 0;
      return (parseFloat(this.chartData.data.max) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    },
    chartConfig() {
      if (!(this.chartData && this.chartData.data && this.chartData.data.count)) return {};

      const labels = Array.from({ length: this.max_value - this.min_value + 1 }, (_, i) => i + this.min_value);
      const values = labels.map((label) => this.chartData.data.count[label] || 0);
      const colors = labels.map((label) => this.buttonColor(label));

      return {
        labels: labels,
        datasets: [
          {
            label: 'Respostas',
            backgroundColor: colors,
            data: values,
          },
        ],
      };
    },
  }
}
</script>
